import { render, staticRenderFns } from "./VersionsDialog.vue?vue&type=template&id=c1688444&scoped=true"
import script from "./VersionsDialog.vue?vue&type=script&lang=ts"
export * from "./VersionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./VersionsDialog.vue?vue&type=style&index=0&id=c1688444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1688444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1688444')) {
      api.createRecord('c1688444', component.options)
    } else {
      api.reload('c1688444', component.options)
    }
    module.hot.accept("./VersionsDialog.vue?vue&type=template&id=c1688444&scoped=true", function () {
      api.rerender('c1688444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/VersionsDialog.vue"
export default component.exports